import { z } from 'zod';

import { HttpsUrl } from './primitives.js';

/**
 * Enterprise remote-config polling. Runtime fetches the endpoint, sends
 * `If-None-Match` if it has an ETag, parses through the same schema, and
 * swaps the live config on success. Failures (network, parse, sig mismatch)
 * leave the existing config in place.
 *
 * Minimum poll interval is 60s by schema constraint — we do not want devices
 * hammering customer endpoints. Faster updates require a push architecture
 * and are a v2 conversation.
 */
export const RemoteConfig = z.object({
  enabled: z.boolean(),
  // https only — the config body (and any ETag auth) crosses this in the clear
  // otherwise.
  endpoint: HttpsUrl.optional(),
  pollIntervalSeconds: z.number().int().min(60).max(86400).default(300),
  useETag: z.boolean().default(true),
});
export type RemoteConfig = z.infer<typeof RemoteConfig>;
